module.exports = __webpack_public_path__ + "img/documents.7c5ca34d.svg";